import styles from "./EventListGuest.module.css";
import eventImg from "../../../../assets/eventImg.png";
import { Col, List, Row } from "antd";
import SearchInput from "../../../../components/searchInput/SearchInput";
import SubmitButton from "../../../../components/submitButton/SubmitButton";
import TextComponent from "../../../../components/textComponent/TextComponent";
import { useWatch } from "antd/es/form/Form";
import useWindowDimensions from "../../../../hooks/useWindowDimensions";
import { useNavigate } from "react-router-dom";
import { useEffect, useState, useRef } from "react";
import ProgressBar from "@ramonak/react-progress-bar";
import { roles } from "../../../../config/roles";
import Storage from "../../../../utills/AsyncStorage";
import { EventMiddleware } from "../../../../Store/Middlewares/EventMiddleware";
import { useDispatch, useSelector } from "react-redux";
import moment from "moment";
import { getUpComingEvents } from "../../../../Store/Actions/EventAction";
import { showAlert } from "../../../../Store/Actions/GeneralActions";

// const guestsRows = [
//   {
//     name: "Wedding Rehearsal",
//     address: "3707 Irving Place, Arnold, MO 63010",
//     date: "May 12, 2023",
//     time: "8:30 PM",
//     guestsPresent: 20,
//     guestsTotal: 30,
//     active: true,
//   },
//   {
//     name: "Wedding Rehearsal",
//     address: "3707 Irving Place, Arnold, MO 63010",
//     date: "May 12, 2023",
//     time: "8:30 PM",
//     guestsPresent: 20,
//     guestsTotal: 30,
//     active: false,
//   },
//   {
//     name: "Wedding Rehearsal",
//     address: "3707 Irving Place, Arnold, MO 63010",
//     date: "May 12, 2023",
//     time: "8:30 PM",
//     guestsPresent: 20,
//     guestsTotal: 30,
//     active: false,
//   },
// ];

const TableHeader = ({ item }) => {
  return (
    <Row className={styles.listItemFirst} style={{ cursor: "default" }}>
      <Col xs={24} lg={9}>
        <div className={styles.itemGroup1First}>
          <TextComponent text={item.name} textClass={styles.eventTitle} />
        </div>
      </Col>
      <Col xs={24} lg={15}>
        <Row className={styles.itemGroup2First}>
          <Col lg={7} xl={6} className={styles.group2Col}>
            <TextComponent text={item.date} />
          </Col>
          <Col lg={7} xl={6} className={styles.group2Col}>
            <TextComponent text={item.time} />
          </Col>
          <Col lg={7} xl={6} className={styles.group2Col}>
            <TextComponent text={item.guests} textClass={styles.guests} />
          </Col>
        </Row>
      </Col>
    </Row>
  );
};

const LeftGroup = ({ item }) => {
  return (
    <div className={styles.itemGroup1}>
      <div className={styles.greenCircle}></div>
      <img src={item?.image} className={styles.eventImage}></img>
      <div className={styles.textGroup}>
        <TextComponent text={item?.name} textClass={styles.eventTitle} />
        <TextComponent text={item?.address} textClass={styles.eventAddr} />
      </div>
    </div>
  );
};

const RightGroup = ({ item }) => {
  const navigate = useNavigate();
  return (
    <Row className={styles.itemGroup2}>
      <Col xs={24} sm={8} lg={7} xl={6} className={styles.group2Col}>
        <TextComponent text="Event Date" textClass={styles.infoTitle} />
        <TextComponent text={moment(item?.date).format("MMM DD")} />
      </Col>
      <Col xs={24} sm={8} lg={7} xl={6} className={styles.group2Col}>
        <TextComponent text="Event Time" textClass={styles.infoTitle} />
        <TextComponent
          text={
            moment(item?.date).format("ddd") +
            " " +
            moment(item?.start_time).format("hh:mm A")
          }
        />
      </Col>
      <Col xs={24} sm={8} lg={7} xl={6} className={styles.group2Col}>
        <TextComponent text="Guests" textClass={styles.infoTitle} />
        <TextComponent
          text={item?.no_of_attendee + "/" + item?.no_of_guest}
          textClass={styles.guests}
        />
        <ProgressBar
          completed={(item?.no_of_attendee / item?.no_of_guest) * 100}
          className={styles.bar}
          labelClassName={styles.labelBar}
          bgColor="var(--primary-color)"
          height="8px"
          isLabelVisible={false}
        />
      </Col>
    </Row>
  );
};

const EventListGuest = ({ showCreateBtn }) => {
  const events = useSelector((state) => state.EventReducer.EventHistory);
  const user = useSelector((state) => state.AuthReducer.user);
  const ref = useRef();
  const [modalOpen, setModalOpen] = useState(false);
  const [search, setSearch] = useState();
  const { height, width } = useWindowDimensions();
  const [loading, setloading] = useState(true);
  const [Hloading, setHloading] = useState(true);
  const [Events, setEvents] = useState([]);

  const navigate = useNavigate();
  const dispatch = useDispatch();
  const role = Storage.getERole("@role");
  //   const EventDetails = useSelector((state) => state.EventReducer.EventDetails);
  console.log("Events", events);

  useEffect(() => {
    let userData = {
      status: "",
      name: "",
    };
    dispatch(EventMiddleware.getEvents(userData)).then((data) => {});
  }, []);

  const onSearch = (val) => {
    let userData = {
      status: "",
      name: val,
    };
    setSearch(val);
    clearTimeout(ref.current);
    ref.current = setTimeout(() => {
      setloading(true);
      setHloading(true);
      dispatch(EventMiddleware.getEvents(userData))
        .then((data) => {
          setloading(false);
          setHloading(false);
        })
        .catch(() => {
          setloading(false);
          setHloading(false);
        });
    }, 1500);
  };

  const headerRow = {
    name: `You have ${events?.length} upcoming ${
      events?.length > 1 ? "events" : "event"
    }`,
    date: "Event Date",
    time: "Event Time",
    guests: "Guests",
  };

  return (
    <>
        <Col
         style={{width: "100%"}}
        >
          <SearchInput
            value={search}
            onChange={(e) => onSearch(e.target.value)}
            placeholder="Search"
          />
        </Col>
        
      <List
        header={<TableHeader item={headerRow} />}
        className={styles.list}
        itemLayout={width > 991 ? "horizontal" : "vertical"}
        dataSource={events}
        renderItem={(item, index) => (
          <List.Item
            className={styles.listItem}
            onClick={() => {
              navigate("/permission", {
                state: { event_id : item?.id },
              });
            }}
          >
            <Col xs={24} lg={9}>
              <LeftGroup item={item} />
            </Col>
            <Col xs={24} lg={15}>
              <RightGroup item={item} />
            </Col>
          </List.Item>
        )}
      />
    </>
  );
};

export default EventListGuest;
